import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col-12 d-flex bd-highlight align-content-center" }
const _hoisted_2 = { class: "card-title p-2 w-100 bd-highlight" }
const _hoisted_3 = { class: "p-2 bd-highlight mt--2 pt--1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sync-alt" })
], -1)
const _hoisted_6 = { class: "p-2 bd-highlight ml--2 mt--2 h-100" }
const _hoisted_7 = { class: "mb--2" }
const _hoisted_8 = { class: "col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-3" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "card-category" }

export interface Irow {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	row: any;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	rowIndex: any;
}

import { ref, computed, watch } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
	tableData: { type: [Object], required: true },
	disabled: { type: Boolean, required: false, default: false },
	tittle: { type: String, required: false, default: "" },
	load: { type: Boolean, required: false, default: false },
	tittlebtn: { type: String, required: false, default: "" },
	btn: { type: Boolean, required: false, default: false },
	cardClass: { type: String, required: false },
	filter: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props


const pagination = {
	perPage: 6,
	currentPage: 1,
	perPageOptions: [6, 10, 25, 50],
	total: 0,
};
const total = computed(() => {
	return rawData?.value?.length;
});
const rawData = computed(() => {
	return props.tableData?.td?.filter((data: { Comentario: string }) => {
		var item = false;
		Object.entries(data).forEach(([, value]) => {
			item =
				item || value.toLowerCase().includes(model.value.search.toLowerCase());
			if (item) {
				return;
			}
		});
		return !model.value.search || item;
	});
});

const pagedData = computed(() => {
	return rawData?.value?.slice(from.value, to.value);
});
const from = computed(() => {
	return (
		model.value.pagination.perPage * (model.value.pagination.currentPage - 1)
	);
});

const to = computed(() => {
	let highBound = from.value + model.value.pagination.perPage;
	if ((total.value as number) < highBound) {
		highBound = total.value as number;
	}
	return highBound;
});

const model = ref({
	pagination,
	search: "",
});
watch(
	() => props.disabled,
	() => {
		if (props.disabled) model.value.search = "";
	}
);
const tableRowClassName = ({
	row,
}: {
	row: any;
	rowIndex: number;
}) => {
	if ("tiempo_pausa" in row && "tiempo_total" in row)
		if (row.tiempo_pausa > row.tiempo_total) {
			return "table-danger";
		} else if (row.tiempo_pausa < row.tiempo_total) {
			return "table-success";
		}
	return "";
};

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_base_pagination = _resolveComponent("base-pagination")!
  const _component_card = _resolveComponent("card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_card, {
    class: _normalizeClass(props.cardClass)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(props.tittle), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_popover, {
            placement: "top",
            content: "Recargar",
            "show-after": 700,
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              _hoisted_4,
              (props.btn)
                ? (_openBlock(), _createBlock(_component_base_button, {
                    key: 0,
                    type: "default",
                    onClickCapture: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('refresh'))),
                    style: {"height":"43px"},
                    disabled: props.disabled
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          (props.filter)
            ? (_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                modelValue: model.value.search,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.search) = $event)),
                size: "large",
                placeholder: "Buscar",
                "input-style": "height: 43px"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_select, {
          size: "small",
          class: "select-primary pagination-select mr--2",
          modelValue: model.value.pagination.perPage,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.value.pagination.perPage) = $event)),
          placeholder: "Per page"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagination.perPageOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                class: "select-primary",
                key: item,
                label: item,
                value: item
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _unref(pagedData),
        "row-key": "id",
        "header-row-class-name": "thead-light",
        border: "",
        fixed: "",
        style: {"width":"100%"},
        "row-class-name": tableRowClassName
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableData?.th, (column) => {
            return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
              sortable: "",
              key: column.value
            }, column, {
              prop: column.value,
              label: column.text,
              "min-width": "130"
            }), null, 16, ["prop", "label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, props.load]
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, " Showing " + _toDisplayString(_unref(from) + 1) + " to " + _toDisplayString(_unref(to)) + " of " + _toDisplayString(_unref(total)) + " entries ", 1)
          ]),
          _createVNode(_component_base_pagination, {
            class: "pagination-no-border",
            modelValue: model.value.pagination.currentPage,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.value.pagination.currentPage) = $event)),
            "per-page": model.value.pagination.perPage,
            total: _unref(total)
          }, null, 8, ["modelValue", "per-page", "total"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})